import { useMutation, useQueryClient } from '@tanstack/react-query';
import { completeCancellation } from '../services/cancellation';
import type { CompletionOption } from '../types/cancellation.types';
import { agreementKeys } from './agreementKeys';

interface CompleteInput {
    option: CompletionOption;
    note: string;
}

export function useCompleteCancellation(agreementId: string) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ option, note }: CompleteInput) => completeCancellation(agreementId, option, note),
        onSettled: () => {
            void queryClient.invalidateQueries({ queryKey: agreementKeys.detail(agreementId) });
            void queryClient.invalidateQueries({ queryKey: agreementKeys.history(agreementId) });
        },
    });
}
